import * as React from 'react';

import { useTagInputHandlers } from '../../../../hooks/tagCloudTargeting';
import { TagEditorProps } from '../../../../typings/tagCloudTargeting';
import { TagSuggestDecorator } from '../../TagSuggestDecorator/TagSuggestDecorator';

export const TagInputEditor: React.FC<TagEditorProps> = React.memo(props => {
    const { onRefChange, onFocus } = props;
    const { onKeyDown, onBlur, onPaste, value, onChange } = useTagInputHandlers(props);

    return (
        <TagSuggestDecorator
            text={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onFocus={onFocus}
            onBlur={onBlur}
            onPaste={onPaste}
            onRefChange={onRefChange}
        />
    );
});
